<script setup lang="ts">
import { PromoExpiredProps } from "./PromoExpired.props"

const props = defineProps<PromoExpiredProps>()

const dayjs = useDayjs()
const today = dayjs()
const startDate = dayjs(props.startDate)
const endDate = dayjs(props.endDate)

const isPromoExpired = computed(() => today.isAfter(endDate))
const isPromoNotStarted = computed(() => today.isBefore(startDate))

const isLogged = useIsLogged()
</script>

<template>
  <div class="wrapper-promo-expired grid-standard">
    <TextBlocksEmpty
      v-if="startDate && endDate"
      type="promotionExpired"
      :product="message"
      :start-date="startDate"
      :end-date="endDate"
      :promo-not-started-message="promoNotStartedMessage"
      :promo-ended-message="promoEndedMessage"
      :is-promo-expired="isPromoExpired"
      :is-promo-not-started="isPromoNotStarted"
      class="col-span-full"
    />
    <template v-if="!isLogged">
      <ClientOnly>
        <TextBlocksUtility class="negative-margined col-span-full" />
        <template #fallback>
          <SkeletonTextBlockUtility class="negative-margined col-span-full" />
        </template>
      </ClientOnly>
    </template>

    <BannerNewsletter class="col-span-full" v-else />
    <CmsComponentSuperDiscountProducts
      v-bind="products"
      class="negative-margined col-span-full"
    />
  </div>
</template>
